<script lang="ts">
    import { Col,Progress } from "sveltestrap";
    import { ProgressBarsanimated, ProgressBarsanimatedMessage } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Card cardHeader2props="pb-0" CardBodyprops="progress-showcase row">
  <div slot="customHeader2">
    <h5>{ProgressBarsanimated}</h5>
    <span>{@html ProgressBarsanimatedMessage}</span>
  </div>
  <div slot="contentbody">
    <Col>
      <Progress animated value={10} color="primary"></Progress>
      <Progress animated value={25} color="secondary"></Progress>
      <Progress animated value={50} color="success"></Progress>
      <Progress animated value={75} color="info"></Progress>
    </Col>
  </div>
</Card>
